import { notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import util from '@/util'

const { mapActions: modalActions } = createNamespacedHelpers('modals')
const { mapActions: profileActions } = createNamespacedHelpers('profile')

export default {
  methods: {
    ...modalActions(['openModal']),
    ...profileActions(['downloadExportedAssociate', 'sendExportedAssociate']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    getEventOpenPayload(event) {
      if (event.openType === 'sequence') {
        return {
          type: 'sequenceReview',
          data: {
            visible: true,
            associate: this.associate,
            sequence_id: event.metadata.signed_sequence_id ?? event.signed_sequence_id,
            onSave: () => this.$emit('save')
          }
        }
      }

      if (event.openType === 'document') {
        return {
          type: 'documentView',
          data: {
            visible: true,
            associate_id: this.associate.id,
            version: Number(event.metadata.version_number),
            document_id: Number(event.metadata.document_id)
          }
        }
      }

      return undefined
    },

    openEvent(event) {
      const payload = this.getEventOpenPayload(event)

      if (payload) {
        this.openModal(payload)
      }
    },

    async runAction({ action, event }) {
      if (action.key === 'open') {
        this.openEvent(event)

        return
      }

      if (action.key === 'download-url') {
        util.downloadFile(action.url)

        return
      }

      if (action.key === 'download-export') {
        try {
          const url = await this.downloadExportedAssociate({
            associate_id: this.associate.id,
            filters: { [action.filter]: true }
          })

          util.downloadFile(url)
        } catch (error) {
          this.showNotification('error', 'Error', error.message || error)
        }

        return
      }

      if (action.key === 'send-export') {
        try {
          await this.sendExportedAssociate({
            associate_id: this.associate.id,
            email: action.email.toLowerCase(),
            filters: { [action.filter]: true }
          })

          this.showNotification('success', 'Success', 'Document successfully sent to email')
        } catch (error) {
          this.showNotification('error', 'Error', error.message || error)
        }
      }
    }
  }
}
